import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EFPicture from '@elem/compCommon/EFPicture';

import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.HighlightsA');

    const gridData = [
        {
            title: t('card_title_1'),
            desc: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103913407/charger_section5_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744104226116/charger_section5_1_h5.jpg',
        },
        {
            title: t('card_title_2'),
            desc: t('card_desc_2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103913595/charger_section5_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744104227347/charger_section5_2_h5.jpg',
        },
        {
            title: t('card_title_3'),
            desc: t('card_desc_3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103913788/charger_section5_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744104227159/charger_section5_3_h5.jpg',
        },
        {
            title: t('card_title_4'),
            desc: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103914200/charger_section5_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744104226825/charger_section5_4_h5.jpg',
        },
        {
            title: t('card_title_5'),
            desc: '',
            desc1: t('card_desc1_5'),
            desc2: t('card_desc2_5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103914401/charger_section5_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744104226631/charger_section5_5_h5.jpg',
        },
        {
            title: t('card_title_6'),
            desc: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103914012/charger_section5_6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744104226381/charger_section5_6_h5.jpg',
        },
    ];

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} theme="white" />
            <EcoSpaceSmall />
            <div className="alternator-charger-grid-container">
                {gridData?.map((item, index) => (
                    <div key={index} className={`alternator-charger-grid-item grid-item-${index + 1}`}>
                        <div className="alternator-charger-grid-item-img">
                            <EFPicture src={item?.pc} srcPad={item?.pc} srcMobile={item?.h5} />
                        </div>
                        <div className="alternator-charger-grid-item-text">
                            <p className="alternator-charger-grid-item-title">{item?.title}</p>
                            {item?.desc && <p className="alternator-charger-grid-item-desc">{item?.desc}</p>}
                        </div>
                        {index === 4 && (
                            <div className="charger-speed-box">
                                <div className="charger-speed-box-item">
                                    <div className="charger-speed-box-item-chart1" />
                                    <p className="charger-speed-box-item-text">{item?.desc1}</p>
                                </div>
                                <div className="charger-speed-box-item">
                                    <div className="charger-speed-box-item-chart2" />
                                    <p className="charger-speed-box-item-text">{item?.desc2}</p>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
